<div class="base-shadow-list b-0">
  <div class="card b-0 base-shadow-list m-b-10">
    <div class="card-body pt-0 pb-0">
      <div class="row">
        <div class="col-12 main-wrap">
          <div class="row">
            <div class="col-3 menu-wrap">
              <div class="menu-title">Select report</div>
              <input
                class="with-gap blue-radio"
                type="radio"
                name="menu"
                id="feedback-chat"
                routerLink="./feedback-chat"
                routerLinkActive
                [checked]="feedbackChat.isActive"
                #feedbackChat="routerLinkActive"
              />
              <label for="feedback-chat">Feedback chat</label>
              <input
                class="with-gap blue-radio"
                type="radio"
                name="menu"
                id="process-report"
                routerLink="./process-report"
                routerLinkActive
                [checked]="processReport.isActive"
                #processReport="routerLinkActive"
              />
              <label for="process-report">Process report</label>
              <input
                      class="with-gap blue-radio"
                      type="radio"
                      name="menu"
                      id="process-info"
                      routerLink="./process-info"
                      routerLinkActive
                      [checked]="processInfo.isActive"
                      #processInfo="routerLinkActive"
              />
              <label for="process-info">Process info</label>
            </div>
            <div class="col-9 content-wrap">
              <div class="filter-title col">Select filters</div>
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
